// src/components/ui/ApprovalStepItem.jsx
import React from 'react';
import { 
  ListItem, 
  ListItemAvatar, 
  Avatar, 
  ListItemText, 
  Typography,
  useTheme,
  alpha
} from '@mui/material';
import {
  CheckCircleOutline,
  CancelOutlined,
  Person as PersonIcon
} from '@mui/icons-material';
import { format } from 'date-fns';

/**
 * Component for displaying an approval workflow step
 * @param {Object} props
 * @param {Object} props.step - The approval step object
 */
const ApprovalStepItem = ({ step }) => {
  const theme = useTheme();
  
  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return format(new Date(dateString), 'MMM d, yyyy HH:mm');
  };
  
  return (
    <ListItem
      sx={{
        borderLeft: `4px solid ${theme.palette[
          step.status === 'approved' 
            ? 'success' 
            : step.status === 'rejected' 
              ? 'error' 
              : step.status === 'skipped' 
                ? 'warning' 
                : 'grey'
        ].main}`,
        mb: 2,
        bgcolor: alpha(theme.palette[
          step.status === 'approved' 
            ? 'success' 
            : step.status === 'rejected' 
              ? 'error' 
              : step.status === 'skipped' 
                ? 'warning' 
                : 'action'
        ].main, 0.05),
        borderRadius: 1,
      }}
    >
      <ListItemAvatar>
        <Avatar 
          sx={{
            bgcolor: theme.palette[
              step.status === 'approved' 
                ? 'success' 
                : step.status === 'rejected' 
                  ? 'error' 
                  : step.status === 'skipped' 
                    ? 'warning' 
                    : 'action'
            ].main
          }}
        >
          {step.status === 'approved' 
            ? <CheckCircleOutline />
            : step.status === 'rejected' 
              ? <CancelOutlined />
              : <PersonIcon />
          }
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={step.name}
        secondary={
          <React.Fragment>
            <Typography variant="body2" component="span">
              Assigned to: {step.assignedTo?.name || 'Unknown'}
            </Typography>
            <br />
            <Typography variant="body2" component="span">
              Status: {step.status?.charAt(0)?.toUpperCase() + step.status?.slice(1)}
            </Typography>
            {step.actionDate && (
              <>
                <br />
                <Typography variant="body2" component="span">
                  {step.status === 'approved' ? 'Approved on: ' : 'Rejected on: '}
                  {formatDate(step.actionDate)}
                </Typography>
              </>
            )}
            {step.notes && (
              <>
                <br />
                <Typography variant="body2" component="span">
                  Notes: {step.notes}
                </Typography>
              </>
            )}
          </React.Fragment>
        }
      />
    </ListItem>
  );
};

export default ApprovalStepItem;